import LineChart from './LineChart';

export const LINECHART = LineChart;
export const BARCHART = LineChart;